import React, { useState } from 'react';
import { Routes, Route, Link, useNavigate } from 'react-router-dom';
import {
  Box,
  Drawer,
  AppBar,
  Toolbar,
  List,
  Typography,
  Divider,
  IconButton,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Button,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ArticleIcon from '@mui/icons-material/Article';
import MicIcon from '@mui/icons-material/Mic';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import CategoryIcon from '@mui/icons-material/Category';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import SettingsIcon from '@mui/icons-material/Settings';
import LogoutIcon from '@mui/icons-material/Logout';
import AdminDashboard from '../components/admin/AdminDashboard';
import AdminNews from '../components/admin/AdminNews';
import AdminNewsForm from '../components/admin/AdminNewsForm';
import AdminDJs from '../components/admin/AdminDJs';
import AdminDJForm from '../components/admin/AdminDJForm';
import AdminPrograms from '../components/admin/AdminPrograms';
import AdminProgramForm from '../components/admin/AdminProgramForm';
import AdminCategories from '../components/admin/AdminCategories';
import AdminAdmins from '../components/admin/AdminAdmins';
import AdminSettings from '../components/admin/AdminSettings';

const drawerWidth = 240;

const Admin: React.FC = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/login');
  };

  const menuItems = [
    { text: 'Dashboard', icon: <DashboardIcon />, path: '/admin' },
    { text: 'Noticias', icon: <ArticleIcon />, path: '/admin/news' },
    { text: 'DJs', icon: <MicIcon />, path: '/admin/djs' },
    { text: 'Programas', icon: <CalendarMonthIcon />, path: '/admin/programs' },
    { text: 'Categorías', icon: <CategoryIcon />, path: '/admin/categories' },
    { text: 'Administradores', icon: <AdminPanelSettingsIcon />, path: '/admin/admins' },
    { text: 'Configuración', icon: <SettingsIcon />, path: '/admin/settings' },
  ];

  const drawer = (
    <div>
      <Toolbar>
        <Typography variant="h6" noWrap component="div">
          EFECTO<span style={{ color: '#DC143C' }}>FM</span>
        </Typography>
      </Toolbar>
      <Divider />
      <List>
        {menuItems.map((item) => (
          <ListItem key={item.text} disablePadding>
            <ListItemButton component={Link} to={item.path}>
              <ListItemIcon sx={{ color: 'primary.main' }}>
                {item.icon}
              </ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider />
      <List>
        <ListItem disablePadding>
          <ListItemButton onClick={handleLogout}>
            <ListItemIcon sx={{ color: 'error.main' }}>
              <LogoutIcon />
            </ListItemIcon>
            <ListItemText primary="Cerrar Sesión" />
          </ListItemButton>
        </ListItem>
      </List>
    </div>
  );

  return (
    <Box sx={{ display: 'flex' }}>
      <AppBar
        position="fixed"
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` },
          bgcolor: 'background.paper',
        }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1 }}>
            Panel de Administración
          </Typography>
          <Button color="inherit" component={Link} to="/" target="_blank">
            Ver Sitio
          </Button>
        </Toolbar>
      </AppBar>

      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
      >
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidth,
            },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: 'none', sm: 'block' },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidth,
            },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: { sm: `calc(100% - ${drawerWidth}px)` },
        }}
      >
        <Toolbar />
        <Routes>
          <Route path="/" element={<AdminDashboard />} />
          <Route path="/news" element={<AdminNews />} />
          <Route path="/news/new" element={<AdminNewsForm />} />
          <Route path="/news/edit/:id" element={<AdminNewsForm />} />
          <Route path="/djs" element={<AdminDJs />} />
          <Route path="/djs/new" element={<AdminDJForm />} />
          <Route path="/djs/edit/:id" element={<AdminDJForm />} />
          <Route path="/programs" element={<AdminPrograms />} />
          <Route path="/programs/new" element={<AdminProgramForm />} />
          <Route path="/programs/edit/:id" element={<AdminProgramForm />} />
          <Route path="/categories" element={<AdminCategories />} />
          <Route path="/admins" element={<AdminAdmins />} />
          <Route path="/settings" element={<AdminSettings />} />
        </Routes>
      </Box>
    </Box>
  );
};

export default Admin;